// extracted by mini-css-extract-plugin
export default {"root":"Login_root__bIZMZ","paper":"Login_paper__V+SIP","form":"Login_form__HoQ6M","submitButton":"Login_submitButton__zSUjS"};